import api from './api';
import { User, LoginCredentials } from '../types';

class AuthService {
  async login(credentials: LoginCredentials): Promise<{ user: User; token: string }> {
    try {
      // Fetch CSRF token first
      await api.get('/auth/csrf/');
      
      const response = await api.post<{ user: User; token: string }>('/auth/login/', credentials);
      console.log('Login response:', response.data);
      
      const { user, token } = response.data;
      
      // Check if user is admin
      if (user.role !== 'admin') {
        console.error('User role:', user.role);
        throw new Error('Accès réservé aux administrateurs');
      }
      
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_user', JSON.stringify(user));
      
      return { user, token };
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout/');
    } finally {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('admin_user');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch {
        return null;
      }
    }
    return null;
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('admin_token');
    const user = this.getCurrentUser();
    return !!(token && user && user.role === 'admin');
  }
}

const authService = new AuthService();
export default authService;